(function() {
    'use strict';

    // Drop-in replacements for ui-sref on order links an appraiser may click. On click they defer to
    // OrderSummaryNav, which role-gates the destination (appraiser -> v2 order summary, else legacy).
    //   <a order-summary-sref="vm.report.appraisalOrderId">Review Appraisal Order</a>
    //   <a order-summary-messages-sref="vm.order.id">Appraisal Message Board</a>
    angular
        .module('valueconnectApp')
        .directive('orderSummarySref', srefDirective('orderSummarySref', 'goToOrderSummary'))
        .directive('orderSummaryMessagesSref', srefDirective('orderSummaryMessagesSref', 'goToOrderSummaryMessages'));

    function srefDirective(attrName, navMethod) {
        return ['OrderSummaryNav', function(OrderSummaryNav) {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    element.on('click', function(e) {
                        e.preventDefault();
                        scope.$apply(function() {
                            OrderSummaryNav[navMethod](scope.$eval(attrs[attrName]));
                        });
                    });
                }
            };
        }];
    }
})();
